<template>
    <el-dialog :title="'작품 상세보기 (' + art.artId + ')'"
               :visible="true"
               width="80%"
               :before-close="close">
        <div class="row">
            <h3 class="row-title">디자인 결과</h3>
            <div class="image-list">
                <div class="image-item image-item--cover"
                     v-for="resource in resultCoverResourceList"
                     :key="resource.publicPath">
                    <a :href="$S3_PREFIX + resource.publicPath" target="_blank" download>
                        <img :src="$S3_PREFIX + resource.publicPath"
                             :alt="resource.resourceType"/>
                        다운로드
                    </a>
                </div>
            </div>
        </div>

        <div class="row">
            <h3 class="row-title">패턴 출력용 이미지</h3>
            <div class="image-list">
                <div class="image-item image-item--cover"
                     v-for="resource in resultResourceList"
                     :key="resource.publicPath">
                    <a :href="$S3_PREFIX + resource.publicPath" target="_blank" download>
                        <img :src="$S3_PREFIX + resource.publicPath"
                             :alt="resource.resourceType"/>
                        다운로드</a>
                </div>
            </div>
        </div>

        <div v-if="imageResourceList.length > 0"
             class="row">
            <h3 class="row-title">사용된 이미지</h3>
            <div class="image-list">
                <div class="image-item image-item--image"
                     v-for="resource in imageResourceList"
                     :key="resource.publicPath">
                    <a :href="$S3_PREFIX + resource.publicPath" target="_blank" download>
                        <img :src="$S3_PREFIX + resource.publicPath"
                             :alt="resource.resourceType"/>
                        다운로드
                    </a>
                </div>
            </div>
        </div>

        <div v-if="logoResourceList.length > 0"
             class="row">
            <h3 class="row-title">사용된 로고</h3>
            <div class="image-list">
                <div class="image-item image-item--logo"
                     v-for="resource in logoResourceList"
                     :key="resource.publicPath">
                    <a :href="$S3_PREFIX + resource.publicPath" target="_blank" download>
                        <img :src="$S3_PREFIX + resource.publicPath"
                             :alt="resource.resourceType"/>
                        다운로드
                    </a>
                </div>
            </div>
        </div>

        <div class="row">
            <h3 class="row-title">메타데이터</h3>
            <el-table :data="art.metaData"
                      stripe
                      style="width: 100%">
                <el-table-column prop="name"
                                 label="페이지 이름"
                                 width="120">
                </el-table-column>
                <el-table-column label="색상 정보"
                                 width="260">
                    <template slot-scope="scope">
                        <p v-if="scope.row.colors.pattern"
                           class="art-color">바디 색상:
                            <span class="color-tag"
                                  :style="{backgroundColor: scope.row.colors.pattern, color: pickColor(scope.row.colors.pattern)}">
                                {{scope.row.colors.pattern}}
                            </span>
                        </p>
                        <p v-if="scope.row.colors.side"
                           class="art-color">소매 색상:
                            <span class="color-tag"
                                  :style="{backgroundColor: scope.row.colors.side, color: pickColor(scope.row.colors.side)}">
                                {{scope.row.colors.side}}
                            </span>
                        </p>
                        <p v-if="scope.row.colors.sideTemplate"
                           class="art-color">소매 무늬 색상:
                            <span class="color-tag"
                                  :style="{backgroundColor: scope.row.colors.sideTemplate, color: pickColor(scope.row.colors.sideTemplate)}">
                                {{scope.row.colors.sideTemplate}}
                            </span>
                        </p>
                        <p v-if="scope.row.colors.banding"
                           class="art-color">마감 색상:
                            <span class="color-tag"
                                  :style="{backgroundColor: scope.row.colors.banding, color: pickColor(scope.row.colors.banding)}">
                                {{scope.row.colors.banding}}
                            </span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="텍스트 정보">
                    <template slot-scope="scope">
                        <div class="art-text"
                             v-for="(text, index) in scope.row.texts"
                             :key="index">
                            <p>
                                <span class="text-item">문구:
                                    <el-tag type="info"
                                            effect="plain">{{text.text}}</el-tag>
                                </span>
                                <span class="text-item">색상:
                                    <span class="color-tag"
                                          :style="{backgroundColor: text.fill, color: pickColor(text.fill)}">
                                        {{text.fill}}
                                    </span>
                                </span>
                                <span class="text-item">폰트: {{text.fontFamily || '기본'}}</span>
                                <el-tag v-if="text.fontWeight === 'bold'"
                                        size="small"
                                        effect="plain">두껍게
                                </el-tag>
                                <el-tag v-if="text.fontStyle === 'italic'"
                                        size="small"
                                        effect="plain">기울림
                                </el-tag>
                                <el-tag v-if="text.underline"
                                        size="small"
                                        effect="plain">밑줄
                                </el-tag>
                            </p>
                            <el-divider v-if="index !== scope.row.texts.length -1"/>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="close">확인</el-button>
            </span>
    </el-dialog>
</template>

<script>
    import {ART_RESOURCE_TYPE} from '@/const';

    export default {
        name: 'Cafe24ArtDetailModal',
        props: {
            art: {
                type: Object,
                required: true,
            },
        },
        computed: {
            resultCoverResourceList() {
                return this.art.resourceList.filter(r => r.resourceType === ART_RESOURCE_TYPE.RESULT_COVER) || [];
            },
            resultResourceList() {
                return this.art.resourceList.filter(r => r.resourceType === ART_RESOURCE_TYPE.RESULT) || [];
            },
            imageResourceList() {
                return this.art.resourceList.filter(r => r.resourceType === ART_RESOURCE_TYPE.IMAGE) || [];
            },
            logoResourceList() {
                return this.art.resourceList.filter(r => r.resourceType === ART_RESOURCE_TYPE.LOGO) || [];
            },
        },
        methods: {
            pickColor(bgColor) {
                const color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
                const r = parseInt(color.substring(0, 2), 16); // hexToR
                const g = parseInt(color.substring(2, 4), 16); // hexToG
                const b = parseInt(color.substring(4, 6), 16); // hexToB
                const colorList = [r / 255, g / 255, b / 255];
                const c = colorList.map((col) => {
                    if (col <= 0.03928) {
                        return col / 12.92;
                    }
                    return Math.pow((col + 0.055) / 1.055, 2.4);
                });
                const result = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
                return (result > 0.179) ? '#000' : '#fff';
            },
            close() {
                this.$emit('close');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .row {
        margin-bottom: 50px;

        .row-title {
            margin-bottom: 10px;
        }

        .row-title--small {
            margin-bottom: 6px;
        }
    }

    .image-list {
        .image-item {
            display: inline-block;
            margin-right: 10px;
            text-align: center;

            &.image-item--cover {
                width: 300px;
            }

            &.image-item--image {
                width: 200px;
            }

            &.image-item--logo {
                width: 100px;
            }

            img {
                width: 100%;
                border: 1px solid #ddd;
            }
        }
    }

    .art-color {
        line-height: 32px;
        font-size: 14px;
    }

    .color-tag {
        line-height: 16px;
        font-size: 16px;
        display: inline-block;
        padding: 6px 12px;
        font-family: Consolas, serif;
        letter-spacing: 1px;
        border-radius: 5px;
    }

    .art-text {
        margin-bottom: 10px;

        p {
            line-height: 36px;
        }

        .el-tag--info {
            font-size: 16px;
        }

        .text-item {
            display: inline-block;
            margin-right: 10px;
        }
    }
</style>